module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-width-e858e9c8.svg";